import { render, staticRenderFns } from "./deviceTrigger.vue?vue&type=template&id=5304f01a&scoped=true&"
import script from "./deviceTrigger.vue?vue&type=script&lang=js&"
export * from "./deviceTrigger.vue?vue&type=script&lang=js&"
import style0 from "./deviceTrigger.vue?vue&type=style&index=0&id=5304f01a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304f01a",
  null
  
)

export default component.exports